import React from 'react';
import styled from 'styled-components';
import Sidebar from './sidebar/Sidbar';

const LayoutContainer = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
`;

const Content = styled.div`
  flex-grow: 1;
  padding: 20px;
  background-color: #ecf0f1;
  overflow-y: auto;
  padding-left: 250px;
`;

const MainLayout = ({ children }) => (
  <LayoutContainer>
    <Sidebar />
    <Content>{children}</Content>
  </LayoutContainer>
);

export default MainLayout;